import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as hotelActions from './../../../../../actions/hotelAction';
import * as rateAction from './../../../../../actions/rateAction';
import RateCompare from './RateCompareDetail';

const mapStateToProps = state => {
    return {
        hotelState: state.hotelReducer,
        rateState: state.rateReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListRates: (hotelId) => dispatch(rateAction.getListRates(hotelId)),
        getListRateCompare: (filters) => dispatch(hotelActions.getListRateCompare(filters)),
        createRateCompare: (data) => dispatch(hotelActions.createRateCompare(data)),
        updateRateCompare: (data) => dispatch(hotelActions.updateRateCompare(data)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RateCompare));